import {
  FETCH_CATEGORY_COUNTS_QUERY,
  FETCH_TAG_LIST_QUERY,
} from "../../graphQL/queries/tagQueries";

export const fetchTagList = FETCH_TAG_LIST_QUERY;
export const fetchCategoryCounts = FETCH_CATEGORY_COUNTS_QUERY;
